import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        showFilter: '=',
        filter: '=',
        defaultFilter: '=',
        list: '='
    },
    template: `
        <div class="table-filters">
            <form class="form form-filter" ng-if="vm.showFilter===true" ng-submit="vm.applyFilter()">
                <div class="fields">
                 <div class="row row-md row-flex02">
                        <span class="label">{{ 'planning.Only employees without personal deadline' | translate }}</span>
                        <div class="items">
                            <label class="switch01">
                                <input type="checkbox"
                                    name="switch"
                                    ng-model="vm.filter.isWithoutDeadlineOnly"
                                ><span></span>
                            </label>
                        </div>
                    </div>
                    <div class="row row-flex02">
                        <span class="label">{{ 'planning.Also display planned employees' | translate }}</span>
                        <div class="items">
                            <label class="switch01">
                                <input type="checkbox"
                                    name="switch"
                                    ng-model="vm.includePlannedUsers"
                                    ng-change="vm.filter.excludePlannedUsers=!vm.includePlannedUsers"
                                ><span></span>
                            </label>
                        </div>
                    </div>
                    <div class="row row-md row-flex02">
                        <span class="label">{{ 'planning.Also display employees added to started automated planning group' | translate }}</span>
                        <div class="items">
                            <label class="switch01">
                                <input type="checkbox"
                                    name="switch"
                                    ng-model="vm.filter.includeApgEmployees"
                                    ng-change="vm.filter.excludeApgUsers=!vm.filter.includeApgEmployees"
                                ><span></span>
                            </label>
                        </div>
                    </div>
                    <div class="row">
                        <label class="label">{{ 'planning.Working since' | translate }}
                            <small>({{ 'planning.From' | translate }})</small>
                        </label>
                        <div class="item">
                            <datepicker-api ng-model="vm.filter.workingSinceFrom"></datepicker-api>
                        </div>
                    </div>
                    <div class="row">
                        <label class="label">{{ 'planning.Working since' | translate }}
                            <small>({{ 'planning.To' | translate }})</small>
                        </label>
                        <div class="item">
                            <datepicker-api ng-model="vm.filter.workingSinceTo"></datepicker-api>
                        </div>
                    </div>
                </div>
                <ul class="actions01">
                    <li><input type="button" ng-click="vm.resetFilter()" class="btn discrete" value="{{ 'filter.Reset' | translate }}"></li>
                    <li><input type="submit" class="btn main" value="{{ 'filter.Filter' | translate }}"></li>
                </ul>
                <button type="submit" class="hidden" >{{ 'filter.Filter' | translate }}</button>
            </form>
        </div>
    `
})
export default class {
    constructor () {
        this.includePlannedUsers = false;
    }

    applyFilter () {
        this.list.fetch(this.filter);
    }

    resetFilter () {
        this.filter = angular.copy(this.defaultFilter);
        this.includePlannedUsers = !this.filter.excludePlannedUsers;
        this.filter.includeApgEmployees = !this.filter.excludeApgUsers;
        this.applyFilter();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/planning/needs/deadline/filter/index.js